export enum AutogiroSettingsEnum {
  monthly = 1,
  annually = 6,
}
